import { render } from "./Navbar.vue?vue&type=template&id=3edc4936&scoped=true"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"

import "./Navbar.vue?vue&type=style&index=0&id=3edc4936&scoped=true&lang=scss"
import "./Navbar.vue?vue&type=style&index=1&id=3edc4936&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3edc4936"]])

export default __exports__